import { ScreenLayout } from '@components/Layouts'
import { TrackingChart } from '@components/Tracking'
import { getTrackingConfig } from '@components/Tracking/trackingConfig'
import { useAuthStore } from '@stores/auth'
import { useTrackingEventsStore } from '@stores/trackingEvents'
import { useMemo } from 'react'
import styled from 'styled-components/native'
import { isSupportedTrackingType } from '../helpers'

const Wrapper = styled.View`
  flex: 1;
`

export function TrackingDetails() {
  const [trackingType] = useTrackingEventsStore((state) => [state.selectedTrackingType])
  const [user] = useAuthStore((state) => [state.user])
  const isSupported = isSupportedTrackingType(trackingType)

  const trackingConfig = useMemo(() => {
    return !!trackingType && getTrackingConfig(trackingType)
  }, [user, trackingType])

  if (!trackingConfig) return null

  return (
    <ScreenLayout title={trackingConfig.title} hasBack isStatic>
      {isSupported && (
        <Wrapper>
          <TrackingChart trackingConfig={trackingConfig} trackingType={trackingType} isControlled />
        </Wrapper>
      )}
    </ScreenLayout>
  )
}
